import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export const RequireAuth = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/portal/login" state={{ from: location }} replace />;
  return children;
};

export const RequireAdmin = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/portal/login" state={{ from: location }} replace />;
  if (user.role !== 'admin') return <Navigate to="/portal" replace />;
  return children;
};

const FullScreenLoader = () => (
  <div className="min-h-screen grid place-items-center bg-slate-50">
    <div className="animate-pulse text-slate-500">Loading...</div>
  </div>
);
